export default __webpack_public_path__ + "static/media/step4.b47a431b.png";